import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import "@progress/kendo-date-math/tz/all";
import { IconComponent, IconName } from '@src/app/shared/components';
import { UserRole } from '@src/app/shared/enums';
import { permissionListWithoutDeprecated, User } from '@src/app/shared/models';
import { CoreUtilsService } from '@src/app/shared/services';
import { ToggleMenuComponent, ToggleMenuType } from "../../../shared/components/toggle-menu/toggle-menu.component";
import { UserMenuToggleComponent } from "../user-menu-toggle/user-menu-toggle.component";

@Component({
    selector: 'cs-user-menu',
    imports: [
        CommonModule,
        ButtonModule,
        LayoutModule,
        ButtonsModule,
        IconComponent,
        ToggleMenuComponent,
        RouterLink,
        UserMenuToggleComponent
    ],
    templateUrl: './user-menu.component.html',
    styleUrl: './user-menu.component.scss'
})
export class UserMenuComponent {
  private readonly utils = inject(CoreUtilsService);
  public readonly closeEvent = output();
  public user = input<User>();

  public readonly validRoleList = computed(() => {
    if (!this.user()?.roles) {
      return [];
    }

    return permissionListWithoutDeprecated
      .filter(item => this.user()?.roles?.includes(item.name as UserRole))
      .map(item => ({
        text: item.label,
        isAdmin: [UserRole.CARGO_SIGNAL_ADMINISTRATOR].includes(item.name as UserRole) || false
      }));
  });

  public readonly isMoreThanOneRole = computed(() => this.validRoleList()?.length > 1);
  public firstRoleTitle = computed(() => this.validRoleList()?.[0]?.text);

  public subItemsUserSettings: ToggleMenuType = {
    title: 'Settings',
    url: '/user-settings',
    items: [
      { text: 'Profile', url: 'profile', icon: 'accountCircle' as IconName, isEnable: this.utils.isFeatureEnabled('userSettingsProfile') },
      { text: 'Preferences', url: 'preferences', icon: 'tune' as IconName, isEnable: true },
      { text: 'Notifications', url: 'notifications', icon: 'alarm' as IconName, isEnable: this.utils.isFeatureEnabled('userNotifications') },
      { text: 'Activity', url: 'audits', icon: 'schedule' as IconName, isEnable: this.utils.isFeatureEnabled('legacyAuditLog') },
    ]
  }

  contactInfo = {
    email: {
      value: 'support@cargosignal.com',
      string: 'support@cargosignal.com'
    },
    phone: {
      value: '12065583500',
      string: '+1 (206) 558-3500'
    }
  }

  logout = output();

  feedbackUrl = this.utils.getEnvironmentVariable("feedbackUrl") as string;

  public handleLogout(): void {
    this.logout.emit();
  }
}
